export default __webpack_public_path__ + "images/U5.4316f6c.png";